import Image, { StaticImageData } from 'next/image';
import React from 'react';

interface CardProps {
  image: StaticImageData;
  name: string;
}

const Card: React.FC<CardProps> = ({ image, name }) => {
  return (
    <React.Fragment>
      <div className='  flex flex-col    px-4'>
        <span className='relative z-10 w-[200px] h-[200px]'>
          <div>
            <Image
              src={image}
              alt='Awards'
              className='shadow-lg rounded-xl'
              width={200}
              height={200}
            />
          </div>

          <span className='bg-gradient-to-t w-full right-0 bottom-0 from-black via-black to-transparent  text-white absolute rounded-b-xl pt-2  border-t border-gray-200 z-20 flex text-xs font-medium items-end'>
            <span className=' p-3'>
              <p>{name}</p>
            </span>
          </span>
        </span>
      </div>
    </React.Fragment>
  );
};
export default Card;
